import Swal from 'sweetalert2';

export const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

export const notifyError = (title, text) => {
    Swal.fire({
        icon: 'error',
        title: `<span className="text-2xl font-bold text-gray-800">${title}</span>`,
        text: text,
        confirmButtonColor: '#2563eb',
        confirmButtonText: 'Entendido',
        padding: '2rem',
        color: '#374151',
        background: '#ffffff',
        borderRadius: '1.5rem',
        customClass: {
            popup: 'rounded-3xl shadow-2xl border border-gray-100',
            confirmButton: 'px-8 py-3 rounded-xl font-bold uppercase tracking-wider'
        }
    });
};

export const notifySuccess = (title, text) => {
    Swal.fire({
        icon: 'success',
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 2000,
    });
};